import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useMembers = () => {
	return useQuery({
		queryKey: ["partner", "members"],
		queryFn: partnerApiService.listMembers,
	});
};
